// extracted by mini-css-extract-plugin
export var cardIcon = "_4a-2";
export var checkboxCard = "_4a-0";
export var checkboxCardSelected = "_4a-1";
export var inputBlocker = "_4a-3";